import "./style.css";
import Api from "../Api";

import { tablet } from "@/App/breakpoints";

export default class ArticlesAndPublicationsGrid {
  static selector = ".articles-and-publications-grid";

  constructor(block) {
    this.block = block;

    this.page = 1;

    this.itemsContainer = this.block.querySelector(
      ".articles-and-publications-grid__inner"
    );
    this.loadMoreButton = this.block.querySelector(
      ".articles-and-publications-grid__load-more"
    );
    this.itemsDescriptions = this.block.querySelectorAll(
      ".articles-and-publications-grid__item-description"
    );

    // get input with filter values (filters can be placed anywhere on the page)
    this.postTypeFilter = document.querySelector(
      "input[name='apGridPostType']"
    );
    this.topicFilter = document.querySelector("select[name='apGridTopic']");
    this.dateFromFilter = document.querySelector(
      "input[name='apGridDateFrom']"
    );
    this.dateToFilter = document.querySelector("input[name='apGridDateTo']");
    this.filterApply = document.querySelector(
      ".filters-header__actions-button--apply"
    );
  }

  setupBackgroundImages = () => {
    this.backgroundImages = this.block.querySelectorAll(
      ".articles-and-publications-grid__item-picture"
    );

    this.backgroundImages.forEach(backgroundImage => {
      const backgroundUrl = backgroundImage.dataset.large;
      let image = new Image();
      image.onload = () => {
        let backgroundLarge = backgroundImage.querySelector(
          ".articles-and-publications-grid__item-picture-background--large"
        );
        backgroundLarge.style.backgroundImage = "url('" + backgroundUrl + "')";
        backgroundLarge.classList.add(
          "articles-and-publications-grid__item-picture-background--large--loaded"
        );
      };
      image.src = backgroundUrl;
    });
  };

  ellipsizeTextBox = el => {
    if (el.ellipsizeWidth && el.ellipsizeWidth === el.offsetWidth) {
      return;
    }

    if (!el.originalWords) {
      el.originalWords = el.innerText.split(" ");
    } else {
      el.innerText = el.originalWords.join(" ");
    }

    el.ellipsizeWidth = el.offsetWidth;

    const wordArray = [...el.originalWords];
    while (el.scrollHeight > el.offsetHeight) {
      wordArray.pop();
      el.innerHTML = wordArray.join(" ") + "&hellip;";
    }
  };

  getResults = () => {
    this.page = 1;

    const postType = this.postTypeFilter?.value ?? "";
    const topic = this.topicFilter?.value ?? "";
    const from = this.dateFromFilter?.value ?? "";
    const to = this.dateToFilter?.value ?? "";

    Api.getPosts({
      postType,
      topic,
      from,
      to,
      mode: "ap-grid"
    }).then(this.updateGridItems);
  };

  getMore = async e => {
    this.loadMoreButton.classList.add(
      "articles-and-publications-grid__load-more--loading"
    );
    this.loadMoreButton.disabled = true;

    this.page += 1;

    const postType = this.postTypeFilter?.value ?? "";
    const topic = this.topicFilter?.value ?? "";
    const from = this.dateFromFilter?.value ?? "";
    const to = this.dateToFilter?.value ?? "";

    const response = await Api.getPosts({
      postType,
      topic,
      from,
      to,
      mode: "ap-grid",
      page: this.page
    });

    this.appendMore(response);
  };

  appendMore = payload => {
    console.log(payload);

    if (payload && payload.html) {
      this.itemsContainer.innerHTML += payload.html;
      this.itemsContainer.style.display = "";

      window.App.initArea(this.itemsContainer);
      this.setupBackgroundImages();
    } else {
      this.page -= 1;
      console.log(this.page);
    }

    this.updateLoadMoreButtonState();
  };

  updateLoadMoreButtonState = () => {
    const items = this.itemsContainer.querySelectorAll(
      ".articles-and-publications-grid__item"
    );

    if (items.length < 12 * this.page) {
      this.loadMoreButton.style.display = "none";
    } else {
      this.loadMoreButton.classList.remove(
        "articles-and-publications-grid__load-more--loading"
      );
      this.loadMoreButton.disabled = false;
      this.loadMoreButton.style.display = null;
    }
  };

  updateGridItems = payload => {
    // console.log(payload);
    let error = this.block.querySelector(
      ".articles-and-publications-grid__no-results"
    );

    if (payload && payload.html) {
      if (error) {
        error.style.display = "none";
      }

      this.itemsContainer.innerHTML = payload.html;
      this.itemsContainer.style.display = "";

      window.App.initArea(this.itemsContainer);

      this.setupBackgroundImages();
    } else {
      this.itemsContainer.innerHTML = "";
      this.itemsContainer.style.display = "none";

      if (!error) {
        error = document.createElement("div");
        error.classList.add("articles-and-publications-grid__no-results");
        error.innerText = "No results found in your search";
        this.block.append(error);
      }
      error.style.display = "";
    }

    this.updateLoadMoreButtonState();
  };

  onFilterInput = () => {
    if (this.currentView !== "mobile") {
      this.getResults();
    }
  };
  onFilterApply = () => {
    if (this.currentView === "mobile") {
      this.getResults();
    }
  };
  onReady = () => {
    this.topicFilter?.addEventListener("input", this.onFilterInput);
    this.dateFromFilter?.addEventListener("input", this.onFilterInput);
    this.dateToFilter?.addEventListener("input", this.onFilterInput);
    this.filterApply?.addEventListener("click", this.onFilterApply);

    this.setupBackgroundImages();

    window.addEventListener("load", this.onResize);
    this.loadMoreButton?.addEventListener("click", this.getMore);

    this.currentView = window.App.getCurrentView();
  };
  onResize = () => {
    this.itemsDescriptions.forEach(el => this.ellipsizeTextBox(el));

    this.currentView = window.App.getCurrentView();
  };
  onDestroy = () => {
    this.topicFilter?.removeEventListener("input", this.onFilterInput);
    this.dateFromFilter?.removeEventListener("input", this.onFilterInput);
    this.dateToFilter?.removeEventListener("input", this.onFilterInput);
    this.filterApply?.removeEventListener("click", this.onFilterApply);

    window.removeEventListener("load", this.onResize);
    this.loadMoreButton?.removeEventListener("click", this.getMore);
  };
}
